import { CategoryTableInterface } from "../../interfaces/interfaces";

class CategoryTableService {
    public static checkSearchValue = (category: CategoryTableInterface, searchParam: boolean): boolean => {
        return searchParam && category.childCategories && category.childCategories.length !== 0;
    };
}

export default CategoryTableService;
